<template>
  <div class="w-full h-full">
    <div class="container-title-chatbox">
      <h1 class="title-help">Se dici help, siamo qui per aiutarti.</h1>
      <span>Se sono risposte che cerchi, sei nel posto giusto.</span>
    </div>
    <div class="chat-container">
      <div id="responsa"></div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.clearStorageResponsa();
  },
  mounted() {
    window.responsa.init();
  },
  beforeUnmount() {
    window.responsa.unload();
    this.clearStorageResponsa();
  },
  methods: {
    clearStorageResponsa() {
      for (let item in window.localStorage) {
        if (item.includes("responsa")) {
          window.localStorage.removeItem(item);
        }
      }
    }
  }
};
</script>

<route>
  {
    "name": "Help",
      "meta": {
        "order": 11,
        "label": "Help"
    }
  }
</route>

<style scoped>
/* latin-ext */
@font-face {
  font-family: "Bebas Neue";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/bebasneue/v14/JTUSjIg69CK48gW7PXoo9Wdhyzbi.woff2)
    format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF,
    U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Bebas Neue";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/bebasneue/v14/JTUSjIg69CK48gW7PXoo9Wlhyw.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191,
    U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjxAwXjeu.woff2)
    format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF,
    U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wXg.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191,
    U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwaPGR_p.woff2)
    format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF,
    U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwiPGQ.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191,
    U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: "Lato";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50XSwaPGR_p.woff2)
    format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF,
    U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Lato";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50XSwiPGQ.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191,
    U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

body {
  margin: 0;
  padding: 20px;
  display: flex;
  color: #fff;
  font-family: "Lato", sans-serif;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: calc(100vh - 40px);
  width: calc(100vw - 40px);
  overflow: hidden;
  background-image: url("https://www.controcorrente.it/assets/Desktop/IBL_Sito_ControCorrente_Sfondo_Pagine.png");
  background-size: cover;
  background-position: center;
}

@media only screen and (min-width: 768px) {
  .chat-container {
    overflow-y: auto;
  }
}

/* Responsa */

.title-help {
  font-size: 68px;
}

#responsa {
  width: 100%;
  flex-grow: 1;
  overflow-y: auto;
}

body {
  height: 100vh;
  overflow: hidden;
}

@media only screen and (max-width: 348px) {
  .title-help {
    font-size: 22px;
  }
  span {
    font-size: 12px;
  }
}
@media only screen and (max-width: 768px) {
  .title-help {
    font-size: 22px;
  }
  #responsa {
    width: 100%;
  }
  .chat-container {
    scrollbar-width: thin;
    scrollbar-color: #b0b0b0 transparent;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 1vh 0 5vh 0;
  }
  /* custom scrollbar */
  ::-webkit-scrollbar {
    width: 20px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #a8bbbf;
  }
}
.container-title-chatbox {
  text-align: center;
}

h1 {
  font-family: "Bebas Neue", helvetica, cursive !important;
  text-transform: uppercase;
  line-height: 1.175;
  font-size: 64px;
  line-height: 0.85;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
}

span {
  line-height: 1.175;
  text-align: center;
}
</style>
